import { jsx as _jsx } from "react/jsx-runtime";
import { Navigate, useLocation } from 'react-router-dom';
import { APP_ROUTES } from '../../../app.config.vars/routes';
import { apiUrl } from '../../../api/game-mode';
const Redirect = () => {
    const location = useLocation();
    if (location.pathname.startsWith(apiUrl)) {
        return null;
    }
    if (location.pathname.includes('admin')) {
        return _jsx(Navigate, { to: APP_ROUTES.adminManageRallies, replace: true });
    }
    else {
        return _jsx(Navigate, { to: APP_ROUTES.rallies, replace: true });
    }
};
export default Redirect;
